import { render, staticRenderFns } from "./addGoodPage.vue?vue&type=template&id=554b16ec&scoped=true"
import script from "./addGoodPage.vue?vue&type=script&lang=js"
export * from "./addGoodPage.vue?vue&type=script&lang=js"
import style0 from "./addGoodPage.vue?vue&type=style&index=0&id=554b16ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b16ec",
  null
  
)

component.options.__file = "addGoodPage.vue"
export default component.exports